import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Link, withRouter } from '#/renderer/router';
import { useHookstate } from '@hookstate/core';
import { usePathname } from 'next/navigation';

// helpers
import { currencyFormat, imgFormat, chargeFormat, currencyFormatGTM } from '~/helpers/formatter';
import prodHelper from '~/helpers/product';
import useStores from '~/store/StoreHook';
import { cuotaState } from '~/store/States/checkout';
import { usePospagoState } from '~/store/States/pospago';
//import blukai, removido
import { hookstate } from '@hookstate/core';
import { TYPE_PLAN } from '~/store/States/global';

export const esimConfig = hookstate({});

const CartSummaryImg = ({ itemInfo = {} }) => (
  <picture>
    <img src={(itemInfo && itemInfo.images && itemInfo.images.length ? imgFormat('90x90', `${process.env.NEXT_PUBLIC_CDN_PATH}${itemInfo.images[0]}`) : '')} alt="alt" />
  </picture>
);

const CartSummaryDesc = ({ itemInfo = {}, addonsList, quantity, hasEsim = false }) => {
  const esimConfigLocal = useHookstate(esimConfig);
  let specs;
  let isAddOn = false;
  if (Object.keys(itemInfo).length) {
    specs = (itemInfo.attributes).reduce((a, b, i) => {
      const index = `cartSummary-spec-${i}`;
      if (b.identifier === 'def-capacidad' || b.identifier === 'def-color' || b.identifier === 'def-pantalla') {
        a.push(<p key={index}><span>{b.value}</span></p>);
      }
      if (b.identifier === 'attr-conf-tipoproducto' && b.value === 'ADDONS') {
        isAddOn = true;
      }
      if (isAddOn && b.identifier === 'attr-short-description') {
        a.push(<p key={index}><span>{b.value}</span></p>);
      }

      return a;
    }, []);
  }


  const esimConfigToUse = esimConfigLocal.get();
  const conEsimTexto = esimConfigToUse && esimConfigToUse.cart && esimConfigToUse.cart.conEsim ? esimConfigToUse.cart.conEsim : ''

  if (hasEsim) {
    specs.push(<p key={9}><span>{conEsimTexto}</span></p>)
  }

  const fullname = Object.keys(itemInfo).length ? itemInfo.locales[process.env.NEXT_PUBLIC_LOCALE].name.replace(/<br>/, '\n').replace(/<br\/>/, '\n').replace(/\\n/, '\n').split('\n')
    .map((str, index) => <p key={`title--${itemInfo.part_number}-${index}`}>{str}</p>) : '';
  return (
    <div className="cart--summary-desc">
      <b>{addonsList.some(x => x.item_part_number === itemInfo.part_number) ? 'Adicional' : 'Producto'}</b>
      <div>{fullname} {quantity > 1 && `(${quantity})`}</div>
      {specs}
    </div>
  );
};

const CartSummarySub = ({ itemInfo = {}, quantity, cartItem, cart, currencySymbol }) => {
  const attrMap = prodHelper.convertAttributes(itemInfo.attributes);
  const tipo = attrMap['attr-conf-tipoproducto'];
  const tipoPlan = attrMap['attr-conf-tipoplan']?.toUpperCase() || '';
  const precioMensual = attrMap['attr-conf-precio-mensual'];
  const noIncluido = attrMap['attr-conf-todo-incluido']?.toUpperCase() === 'NO';
  let currencyText;
  if (cartItem.part_number_kit) {
    const sp = cartItem.part_number_kit.split('--');
    const plan = sp[1];
    const plazo = sp[2];
    currencyText = currencyFormat(itemInfo.pricing.pospago[plan][plazo].offer_price, 1).split('.');
  } else if (tipo === 'PLAN' && tipoPlan === 'FIJO' && noIncluido) {
    const kitItem = cart.find(it => it.part_number_kit);
    if (kitItem) {
      const sp = kitItem.part_number_kit.split('--');
      const plan = sp[1];
      const plazo = sp[2];
      currencyText = currencyFormat(((kitItem.product.items[0].pricing.pospago[plan][plazo].financing || 0) / plazo) + +precioMensual, 1).split('.');
    }
  } else {
    currencyText = currencyFormat(itemInfo.pricing[process.env.NEXT_PUBLIC_CURRENCY].offer_price * quantity).split('.');
    if (currencyText[0] === '0' && currencyText[1] === '00' && precioMensual) {
      currencyText = currencyFormat(precioMensual, 1).split('.');
    }
  }
  // if (addonsList.some(x => x.item_part_number === itemInfo.part_number)) {
  //   const addOn = addonsList.find(x => x.item_part_number === itemInfo.part_number);
  //   const subtotal = parseFloat(addOn.price * addOn.quantity).toFixed(2).toString().replace('.', '');
  //   const total = currencyFormat(subtotal).split('.');
  //   return (
  //     <div className="cart--summary-sub">
  //       <b>Precio</b>
  //       <p>
  //         <span className="symbol">Q</span>
  //         <span>{total[0]}.</span>
  //         <span className="symbol">{String(total[1]).padStart(2, '0')}</span>
  //       </p>
  //     </div>
  //   );
  // }
  return (
    <div className="cart--summary-sub">
      <b>Precio</b>
      <p>
        <span className="symbol">{currencySymbol}</span>
        <span>{currencyText[0]}.</span>
        <span className="symbol">{currencyText[1]}</span>
      </p>
    </div>
  );
};

const CartSummaryDetail = ({ itemInfo = {}, addonsList, quantity, cartItem, cart, hasEsim, currencySymbol }) => {
  const pospagoState = usePospagoState(!!cartItem.part_number_kit);
  if (pospagoState.config.product_sku_sin_equipo.value === cartItem.part_number) {
    return null;
  }

  const sinEquipoItem = cart.find(x => x.part_number === 'K01_0001_001');

  return (
    <div className="cart--summary-detail">
      <CartSummaryImg itemInfo={itemInfo} />
      <section>
        <CartSummaryDesc itemInfo={itemInfo} addonsList={addonsList} quantity={quantity} hasEsim={hasEsim || sinEquipoItem?.esim}/>
        <CartSummarySub itemInfo={itemInfo} addonsList={addonsList} quantity={quantity} cartItem={cartItem} cart={cart} currencySymbol={currencySymbol} />
      </section>
    </div>
  );
};

const CartSummaryAddress = withRouter(({ cartInfo = {}, location }) => {
  const isPayment = location.pathname === '/checkout/payment';
  let output;
  if (isPayment) {
    return null;
  } else { output = ''; }
  return output;
});

const UI = ({ cartInfo = {}, addonsList, hasPospago, monedaPospago }) => {
  const pathname = usePathname();
  const currencySymbol = hasPospago && monedaPospago?.activo ? monedaPospago.simbolo : process.env.NEXT_PUBLIC_CURRENCY_SYMBOL;
  const [chargeTitle, setChargeTitle] = useState();
  const { orderStore } = useStores();
  const [precio_minimo_incluido, setPrecio_minimo_incluido] = useState('');
  const [alerta, setAlerta] = useState('');
  const [show, setShow] = useState(false);
  let pricing;
  let showing = false;
  const cuotas = useHookstate(cuotaState.cuotas);

  useEffect(() => {
    async function init() {
      await orderStore.getConfigEsim();
      if (!orderStore.getCartConfig || !orderStore.getCartConfig.success) {
        await orderStore.getConfig();
      }

      if (orderStore.getEsimConfig.success) {
        const esimConfigToSet = orderStore.getEsimConfig.data.data;
        esimConfig.set(esimConfigToSet)
      }
      if (orderStore.getCartConfig.success) {
        setChargeTitle(orderStore.getCartConfig.data.data.chargeTitle);
        setAlerta(orderStore.getCartConfig.data.data.alertaPospago || '');
        pricing = orderStore.getCartConfig.data.data.precio_minimo_incluido || 0;
        if (orderStore.getCartConfig.data.data.precio_minimo_incluido) {
          setPrecio_minimo_incluido(parseFloat(orderStore.getCartConfig.data.data.precio_minimo_incluido));
        }
      }
    }
    init();
  }, []);

  let isPospago = false;
  const itemInfo = {};
  const cartDetails = (cartInfo.items || []).map((data, i) => {
    const index = `item--${data.part_number}--${i}`;
    (data.product.items).map((items) => {
      isPospago = isPospago || items.type === TYPE_PLAN;
      itemInfo[items.part_number] = items;
      return items;
    });
    return <CartSummaryDetail hasEsim={data?.esim}  key={index} itemInfo={itemInfo[data.part_number]} addonsList={addonsList} quantity={+data.quantity} cartItem={data} cart={cartInfo.items} currencySymbol={currencySymbol} />;
  });

  // const isRegister = cartInfo && cartInfo.items && cartInfo.items.length === 1;
  let grandTotal;
  if (cartInfo && cartInfo.amount && cartInfo.amount[process.env.NEXT_PUBLIC_CURRENCY]) {
    grandTotal = cartInfo.amount[process.env.NEXT_PUBLIC_CURRENCY].grand_total;
    // if (isRegister) {
    //   addonsList.forEach((e) => {
    //     const price = (Math.round((e.price * e.quantity) * 100) / 100).toFixed(2);
    //     const addOnPrice = price.toString().replace('.', '');
    //     grandTotal = (parseInt(grandTotal, 10) + parseInt(addOnPrice, 10)).toString();
    //   });
    // }
    const isPayment = pathname === '/checkout/payment';
    if (isPayment && cuotas.value > 0) {
      grandTotal /= cuotas.value;
    }
    grandTotal = currencyFormatGTM(grandTotal).split('.');
    const centsTemp = parseInt(grandTotal[1], 10);
    grandTotal[1] = centsTemp < 100 ? centsTemp : centsTemp - 100;
  }

  // if (addOnsList && addOnsList.length === 0) return null;
  // let addOnsDetails = (addonsList || []).map((data) => {
  //   const subtotal = parseFloat(data.price * data.quantity).toFixed(2).toString().replace('.', '');
  //   const total = currencyFormat(subtotal).split('.');
  //   const addOnImg = `/cdn${data.image}`;
  //   return (
  //     <div className="cart--summary-detail fakeCard">
  //       <picture>
  //         <img src={addOnImg} alt={data.description} />
  //       </picture>
  //       <section>
  //         <div className="cart--summary-desc">
  //           <b>Adicional</b>
  //           <p>{ data.description }</p>
  //         </div>
  //         <div className="cart--summary-sub">
  //           <b>Precio</b>
  //           <p><span className="symbol">Q</span><span>{total[0]}.</span><span className="symbol">{String(total[1]).padStart(2, '0')}</span></p>
  //         </div>
  //       </section>
  //     </div>
  //   );
  // });
  // if (!isRegister) addOnsDetails = '';
  let total;
  let total_text;
  if (precio_minimo_incluido){
    const amount = grandTotal ? grandTotal[0] : '';
    const decimals = grandTotal ? String(grandTotal[1]).padStart(2, '0') : '';
    total = `${amount}.${decimals}`;
    total_text = `${amount}.${decimals}`;
    total = parseFloat(total);
    showing = total <= precio_minimo_incluido;
  }

  return (
    <section className="cart--summary">
      <header className="cart--summary-header">
        <p>Resumen de compra</p>
        <Link
          onClick={() => {
            //blukai function, removida
          }}
          to="/cart"
          id="editar-carrito"
        >
          Editar
        </Link>
      </header>
      {cartDetails}
      {/* {isRegister ? addOnsDetails : null} */}
      <aside className="cart--summary-total">
        <b>{cuotas.value ? `Tu compra en ${cuotas.value} cuotas` : 'Total'}:</b>
        <p>
          <span className="symbol">{currencySymbol}</span>
          <span>{grandTotal ? currencyFormat(grandTotal[0], 1).split('.')[0] : ''}.</span>
          <span className="symbol">{grandTotal ? String(grandTotal[1]).padStart(2, '0') : ''}</span>
          {cuotas.value ? <span>/mes</span> : null}
        </p>
      </aside>

      {showing ? chargeFormat(chargeTitle, total_text, currencySymbol) : ''}
      {isPospago && alerta && (
        <div style={showing ? { marginTop: '1rem' } : null} dangerouslySetInnerHTML={{ __html: alerta }} />
      )}
      <CartSummaryAddress cartInfo={cartInfo} />
    </section>
  );
};

UI.propTypes = {
  cartInfo: PropTypes.shape({}),
};

CartSummaryDetail.propTypes = {
  itemInfo: PropTypes.shape({}),
};

CartSummaryDesc.propTypes = {
  itemInfo: PropTypes.shape({}),
};

CartSummarySub.propTypes = {
  itemInfo: PropTypes.shape({}),
};

CartSummaryImg.propTypes = {
  itemInfo: PropTypes.shape({}),
};

CartSummaryAddress.propTypes = {
  cartInfo: PropTypes.shape({}),
};

export default UI;
